import { Box, Card, Typography } from "@mui/material";
import React, { FC } from "react";
import {
  boxIconContainer,
  cardInnerStyle,
  cardStyle,
  cardStyleActive,
  compactCardStyle,
  compactCardStyleActive,
  iconStyle,
} from "./PetCard.style";
import { colorTheme, getSOCStatusDataMap } from "../../utils/SOCUtils";

import AvatarCustom from "../AvatarCustom/AvatarCustom";
import { ChipCustom } from "../../styles/styledComponents";
import { IPetItemResponse } from "../../services/pet-list/pet-list.interface";
import { SocStatusCustomIcon } from "../Icons";

interface IPetCardProps {
  isActive?: boolean;
  icon?: React.ReactElement;
  image?: string;
  title?: string;
  pet?: IPetItemResponse;
  notBold?: boolean;
  petAvatarSize?: number;
  displaySoc?: boolean;
  isWellnessPlan?: boolean;
  isDashBoardPetCardBooking?: { wellnessIconCoordinates: { x: string; y: string },
  wellnessIcon: { width: number, height: number } } | undefined;
  isDisabled?: boolean;
  innerClassName?: string;
  variant?: "default" | "compact";
}

const PetCard: FC<IPetCardProps> = ({
  isActive = false,
  icon,
  image,
  title,
  pet,
  notBold,
  petAvatarSize,
  displaySoc= false,
  isWellnessPlan,
  isDashBoardPetCardBooking,
  isDisabled,
  innerClassName,
  variant = "default",
}) => {
  if (variant === "compact") {
    return (
      <Card sx={isActive ? compactCardStyleActive : compactCardStyle}>
        <Box sx={{
          display: "flex", flexDirection: "column", gap: 1,
          alignItems: "center", justifyContent: "center", p: 1.5,
        }}>
          <AvatarCustom
            image={image}
            name={title || pet?.name}
            width={54}
            height={54}
          />
          {pet && (
            <Typography className="grenette-pro font-semibold !text-lg text-center">
              {pet.name}
            </Typography>
          )}
        </Box>
      </Card>
    );
  }

  return <>
    <Card sx={isActive ? cardStyleActive : cardStyle} className={`${isDisabled ? "!opacity-50 !border-none" : ""}`}>
      <Card sx={cardInnerStyle} className={`relative ${innerClassName || ""}`}>
        <Box sx={boxIconContainer}>
          {
            icon ?
              <Box sx={iconStyle}>
                {icon}
              </Box> :
              <AvatarCustom
                sx={{ margin: "0.5rem" }}
                image={image}
                name={title || pet?.name}
                width={petAvatarSize ? petAvatarSize : 55}
                height={petAvatarSize ? petAvatarSize : 55}
                isWellnessMember={isWellnessPlan}
                isDashBoardPetCardBooking={isDashBoardPetCardBooking}
              />
          }
        </Box>

        <Box>
          {title ? (
            <Typography variant="h4" sx={{ fontSize: "15px" }}>
              {title}
            </Typography>
          ) : null}

          {pet ? (
            <Typography variant="h6">
              {notBold ? (
                <span>{pet?.name}</span>
              ) : (
                <span className="grenette-pro font-semibold !text-lg">{pet?.name}</span>
              )}
            </Typography>
          ) : null}
        </Box>
        {displaySoc && pet && pet.socStatus && <ChipCustom
          icon={<SocStatusCustomIcon type={pet.socStatus as keyof typeof colorTheme} />}
          label={getSOCStatusDataMap(pet.socStatus).label}
          className="!font-semibold !text-xs !py-[0.375rem] !px-2 absolute top-[1rem] right-3"
          color={getSOCStatusDataMap(pet.socStatus).color}
          size="small"
        />}
      </Card>
    </Card>
  </>;
};

export default PetCard;
